"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "taino": {
    "3040748c": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "skipSearch": false
    }],
    "bosco-forte": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "abbb2d3d": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "skipSearch": false
    }],
    "campaccio": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9e09b0d5": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-marina": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d02edc09": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-pianazzo": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fa0bda39": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "skipSearch": false
    }],
    "catatoria": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f524b35e": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "skipSearch": false
    }],
    "cheglio": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1c4d04ca": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "skipSearch": false
    }],
    "colombera": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "595af63e": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "skipSearch": false
    }],
    "madonnina": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "43b0cd58": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "skipSearch": false
    }],
    "monte-della-croce": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b735ed39": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "skipSearch": false
    }],
    "monte-le-casacce": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d682333d": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "skipSearch": false
    }],
    "monzeglio": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d52d4921": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-dei-sassi": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "430ce313": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "skipSearch": false
    }],
    "prato-del-bosco": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d594212b": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "skipSearch": false
    }],
    "ranzitt": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7d7446a8": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "skipSearch": false
    }],
    "roncaccio": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e0bcd751": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "skipSearch": false
    }],
    "san-damiano": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7d0b6259": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "skipSearch": false
    }],
    "vigano": [{
      "hkey": "c3f97e24",
      "slug": "taino",
      "name": "Taino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;